import { Component, OnInit, Input } from '@angular/core';
import { Utility } from 'projects/common/src/app/classes/utility';
import { IGeneralSummaryStatus } from 'src/app/modules/widget/interfaces/general-summary-status';

@Component({
  selector: 'app-general-status-summary',
  templateUrl: './general-status-summary.component.html',
  styleUrls: ['./general-status-summary.component.scss'],
})
export class GeneralStatusSummaryComponent implements OnInit {
  @Input()
  public summaryStatus: IGeneralSummaryStatus;

  @Input()
  public machineType: string;

  @Input()
  public hasSeparator: boolean;

  public imageName: string;

  constructor() {
    this.imageName = '';
  }

  /**
   * init app
   */
  public ngOnInit(): void {
    this.imageName = Utility.getSideMachineIconKey(this.summaryStatus.parentStatusImagePrefix, this.summaryStatus.machineIcon);
  }
}
